import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tongji4",
  "use": "icon-tongji4-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tongji4\"><defs><style type=\"text/css\"></style></defs><path d=\"M875.52 151.552h-2.048C802.816 80.896 709.12 37.888 609.28 31.232v399.36h389.12c-4.096-104.96-48.128-204.8-122.88-279.04z\" p-id=\"2524\" /><path d=\"M537.6 39.424h-29.184c-264.192 0-478.72 214.016-478.72 478.208 0 264.704 214.528 478.72 478.72 478.72 261.632 1.024 475.136-208.896 478.72-470.528V496.64H537.6V39.424z m389.12 518.144c-8.704 99.84-52.736 194.048-124.928 264.192h-2.048c-77.824 76.288-182.272 118.784-291.328 118.784-232.448 0-420.352-187.904-420.352-420.352-1.536-221.184 169.984-406.016 391.168-420.352v457.728H926.72z\" p-id=\"2525\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-tongji4.svg
// module id = I0M8
// module chunks = 175